import { useContext } from 'react';
import { CarouselContext } from '@/contexts/carousel-context';
export default function useCarousel() {
  const context = useContext(CarouselContext);
  if (!context) {
    throw new Error("useCarousel must be used within a <Carousel />");
  }
  return context;
}